/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parallelactiveevents2Inputs */

const en_parallelactiveevents2 = /** @type {(inputs: Parallelactiveevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parallel active events`)
};

const de_parallelactiveevents2 = /** @type {(inputs: Parallelactiveevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parallel aktive Events`)
};

/**
* | output |
* | --- |
* | "Parallel active events" |
*
* @param {Parallelactiveevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const parallelactiveevents2 = /** @type {((inputs?: Parallelactiveevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parallelactiveevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parallelactiveevents2(inputs)
	return de_parallelactiveevents2(inputs)
});
export { parallelactiveevents2 as "parallelActiveEvents" }